const common = {
  "site.name": "51暗网吃瓜",
  "site.tagline": "全网吃瓜第一站",
  "site.description": "每日大赛、网红爆料、黑料吃瓜，热门大瓜不停更",

  "nav.home": "首页",
  "nav.category": "分类",
  "nav.hot": "热门爆料",
  "nav.about": "关于我们",
  "nav.download": "下载APP",

  "footer.copyright": "© 2026 51暗网吃瓜 版权所有",
  "footer.disclaimer": "本站内容来源于网络，仅供娱乐消遣，不构成任何建议。如有侵权请联系删除。",
  "footer.privacy": "隐私政策",
  "footer.terms": "使用条款",
  "footer.contact": "联系我们",

  "hero.tag": "🔥 全网热点实时追踪",
  "hero.title": "51暗网吃瓜",
  "hero.subtitle": "每日大赛不间断，网红塌房第一现场",
  "hero.cta": "立即下载APP",
  "hero.secondary": "浏览最新爆料",

  "section.reveal": "网红爆料",
  "section.reveal.desc": "实锤黑料 · 一手大瓜 · 实时更新",
  "section.reveal.viewAll": "查看全部爆料",

  "section.daily": "每日大赛",
  "section.daily.desc": "全网最热吃瓜大赛实时追踪，不错过任何一个大瓜",
  "section.daily.hot": "实时热榜",

  "section.comments": "网友神评",
  "section.comments.desc": "精选全网最犀利吃瓜评论，句句扎心",
  "section.comments.tag": "💬 吃瓜群众有话说",

  "section.about": "关于51暗网吃瓜",
  "section.about.content": "51暗网吃瓜致力于为广大吃瓜群众提供最新、最全、最劲爆的娱乐八卦资讯。我们汇聚全网热门爆料，追踪每日大赛热点，让每一个吃瓜人都能第一时间掌握最新动态。理性吃瓜，快乐生活。 🍉",

  "cta.title": "下载51暗网吃瓜APP",
  "cta.subtitle": "随时随地 · 大瓜不错过 · 吃瓜更尽兴",
  "cta.button": "立即下载",
  "cta.ios": "iOS 版",
  "cta.android": "安卓版",

  "breadcrumb.home": "首页",
  "breadcrumb.category": "分类",

  "category.all": "全部",
  "category.celebrity": "明星爆料",
  "category.influencer": "网红塌房",
  "category.daily": "每日大赛",
  "category.anonymous": "匿名黑料",
  "category.rumor": "辟谣专区",

  "article.read": "阅读全文",
  "article.time": "发布于",
  "article.source": "来源",
  "article.related": "相关爆料",
  "article.prev": "上一篇",
  "article.next": "下一篇",
  "article.share": "分享",

  "about.title": "关于我们",
  "about.intro": "品牌介绍",
  "about.reputation": "口碑声誉",
  "about.contact": "联系我们",
  "about.intro.content": "51暗网吃瓜成立于2024年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为广大吃瓜群众提供最新、最全、最劲爆的娱乐八卦资讯，涵盖明星爆料、网红塌房、每日大赛、匿名黑料等多个板块。我们坚持真实、客观、及时的原则，让每一位用户都能第一时间获取最热门的吃瓜内容。",
  "about.reputation.content": "51暗网吃瓜自上线以来，凭借海量爆料内容、极快的更新速度和良好的用户体验，赢得了数百万吃瓜群众的信赖与喜爱。我们始终坚持以用户为中心，不断优化产品体验，努力成为中文互联网最受欢迎的吃瓜平台。",
  "about.contact.email": "联系邮箱",
  "about.contact.wechat": "微信公众号",
  "about.contact.qq": "QQ群",
};

export default common;